import __isEmpty from 'lodash/isEmpty';
import styles from './elgrup.module.scss';
import Imatge from 'components/corporatiu/Imatge/Imatge';
import Text from 'components/corporatiu/Text';
import Titol from 'components/corporatiu/Titol';
import clsx from 'clsx';
import TextDesplegable from 'components/corporatiu/TextDesplegable';

export default function ElGrup(props) {
    const { items } = props;

    const stylesDestacat = clsx({
        [styles.destacatBasic]: true,
        [styles.horitzontal]: true
    });

    return (
        <>
            <Titol titol={items?.titol} tipus='menu' tag='h1' estil='titolPagina' />
            <Text text={items?.descripcio} className='gapAfterRow' />
            <div>
                {!__isEmpty(items) &&
                    items?.noticies.map((item, index) => (
                        <div key={`noticia-el-grup-${index}`} className={styles.noticiaItem}>
                            <div key={`destacat-basic-${index}`} className={stylesDestacat}>
                                {item?.imatges && (
                                    <div className={styles.imatgeWrapper}>
                                        <Imatge
                                            imatges={item?.imatges}
                                            className={styles.imatge}
                                            tipus={'web_destacat'}
                                            numColumnsRow='2'
                                            aria-hidden='true'
                                            layout='fill'
                                            priority={false}
                                            data_testid='destacat-img'
                                        />
                                    </div>
                                )}
                                <div className={styles.contentWrapper}>
                                    <Text
                                        tag='h2'
                                        className={styles.titol}
                                        text={item?.titol}
                                        dataTestId='destacat-basic-titol'
                                    />
                                    <Text tag='div' text={item['intro-desplegable']} dataTestId='destacat-basic-entradeta' />
                                </div>
                            </div>

                            {item['descripcio-desplegable'] && <TextDesplegable text={item['descripcio-desplegable']} />}
                        </div>
                    ))}
            </div>
        </>
    );
}
